import { automationInsightsSchema } from '../models/automationAssistant.schema';

export const automationInsights = (queueId: number) => {
  return {
    endpoint: `/queues/${queueId}/automation/insights`,
    method: 'GET',
    responseSchema: automationInsightsSchema,
  } as const;
};
